const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    encryptPseudonyms: {
        entries: {},
        maxCount: 0,
    },
    encryptSinglePseudonyms: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveGuid: null,
});

export default {
    getInitialState
};
